import { useField, useFormikContext } from 'formik';
import {
  Box,
  Flex,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
  InputGroup,
  InputLeftElement,
  Textarea,
  Tooltip,
} from '@chakra-ui/react';
import { useEffect } from 'react';
import { InfoCircle } from '../../icons';

export function TextInput({
  label,
  subLabel,
  inputType,
  leftIcon,
  tooltipLabel,
  isRequired = false,
  ...props
}: any) {
  const [field, meta] = useField(props);
  const formikProps = useFormikContext<any>();

  return (
    <FormControl id={props.id} isInvalid={meta.touched && (meta.error as any)}>
      {label && (
        <Flex align={'center'}>
          <FormLabel
            fontSize="sm"
            fontFamily="heading"
            fontWeight="semibold"
            color="text.secondary2"
            lineHeight="17px"
          >
            {label} {isRequired && '*'}
          </FormLabel>
          {tooltipLabel && (
            <Tooltip
              label="Goal Name is required. Define a clear, concise name and a detailed description for this Objective."
              hasArrow
              placement="top"
            >
              <Box as={'span'} ml={'-6px'} mt={'-6px'}>
                <InfoCircle height={'14px'} width={'14px'} />
              </Box>
            </Tooltip>
          )}
        </Flex>
      )}

      {subLabel && (
        <FormLabel
          fontSize="xs"
          fontFamily="heading"
          fontWeight="normal"
          color="text.secondary"
          lineHeight="17px"
        >
          {subLabel}
        </FormLabel>
      )}

      <InputGroup>
        {leftIcon && (
          <InputLeftElement color="text.secondary" children={leftIcon} />
        )}
        {inputType === 'textarea' ? (
          <Textarea
            {...field}
            {...props}
            border="1px solid"
            borderColor="text.tertiary"
            onBlur={(event) =>
              formikProps.setFieldValue(
                event.target.name,
                event.target.value.trim()
              )
            }
          />
        ) : (
          <Input
            {...field}
            {...props}
            border="1px solid"
            borderColor="text.tertiary"
            onBlur={(event) =>
              formikProps.setFieldValue(
                event.target.name,
                event.target.value.trim()
              )
            }
          />
        )}
      </InputGroup>

      <FormErrorMessage>{meta.error}</FormErrorMessage>
    </FormControl>
  );
}
export default TextInput;
